<template>
	<el-dialog :title="config.title" :visible.sync="dialogVisible" :close-on-click-modal="false" custom-class="warn-dialog-warn" append-to-body width="660px">
		<!--<i v-if="main.icon == 'success'" class="icon i-success-big"></i>-->
		<i class="icon3 i-tpl-warning" v-if="config.icon === 'warn'"></i>
		<i class="icon3 i-tpl-success" v-if="config.icon === 'success'"></i>
		<i class="icon3 i-tpl-ask" v-if="config.icon === 'ask'"></i>
		<i class="icon3 i-tpl-err" v-if="config.icon === 'err'"></i>
		<div v-html="config.warningInfo" style="text-align:center;"></div>
		<p class="dialog-tips" v-show="tips">{{tips}}</p>
		<span slot="footer" class="dialog-footer">
			<el-button type="warning" @click="successBack" round class="large-warning" v-show="config.confirmBtnName">{{config.confirmBtnName}}</el-button>
			<el-button @click="cancelBack" round class="large-warning plain-elbutton" v-show="config.cancelBtnName">{{config.cancelBtnName}}</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'DialogWarn',
	data () {
		return {}
	},
	props: ['showDialog', 'config', 'tips'],
	computed: {
		dialogVisible: {
			get () {
				return this.showDialog
			},
			set (val) {
				this.$emit('update:showDialog', val)
			}
		},
	},

	methods: {
		successBack () {
			this.dialogVisible = false
			if (this.config.successBackName) {
				this.$emit('defined', this.config.successBackName, this.config.successBackParams)
			}
		},
		cancelBack () {
			this.dialogVisible = false
			if (this.config.cancelBackName) {
				this.$emit('defined', this.config.cancelBackName, this.config.cancelBackParams)
			}
		}
	},

}

</script>

<style scoped>
i {
	margin-bottom: 20px;
}

div {
	color: #515567;
	font-size: 22px;
}
.dialog-tips {
	padding-top: 15px;
}
</style>
